export enum AlcolockEventCode {
    Unknown = 0,
    PowerUp = 1,
    InitialSampleFailed = 2,
    RandomSampleFailed = 3,
    InitialSamplePassed = 4,
    RandomSamplePassed = 5,
    PossiblePushStart = 6,
    OverridePeriodStarted = 7,
    OverridePeriodEnded = 8,
    EmergencyOverridePeriodStarted = 9,
    ForcedSampleRequest = 10,
    RandomSampleRequest = 11,
    CallTimeExpired = 12,
    CircumventionBreathRelated = 13,
    CircumventionSuckBack = 14,
    CircumventionBlowingTooHard = 15,
    SystemRearmedStartTimeExpired = 16,
    SystemRearmedRestartTimeExpired = 17,
    TabConnected = 18,
    DriverChangeRequest = 19,
    DriverChangePassed = 20,
    DriverChangeFailed = 21,
    DriverChangeCallExpired = 22,
    ManualSample = 23,
    PassedAfterRandomCallExpired = 24,
    PassedAfterDriverChangeCallExpired = 25,
    FailedAfterRandomCallExpired = 26,
    FailedAfterDriverChangeCallExpired = 27,
    CircumventionInsufficientSample = 28,
    DoorOpened = 29,
    IgnitionOn = 30,
    IgnitionOff = 31,
    DatabaseDeleted = 32, 
    ServiceReminder = 33,
    ServiceExpired = 34
}

export enum AlcolockRecordType {
    AlcoholMeasurement,
    Calibration
}

export enum AlcolockEventGroup {
    Other = 0,
    Fail = 1,
    Circumvention = 2,
    Pass = 3,
    SignificantEvent = 4
}

export enum RingStatus {
    OK,
    Warning,
    Error,
    NoData
}
